import { Fragment, useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  addProducerCode,
  exportProducerCodes,
} from "../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";
import ProducerCodeMainTable from "./ProducerCodeMainTable";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../components/toastNotification";
import MassUpload from "./MassUpload";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { useRecoilValue, useRecoilState, useSetRecoilState } from "recoil";
import { PERMISSIONS } from "../../PermissionsConstants";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import {
  isEditStateProducer,
  rowForEditProducer,
  searchDataProdCode,
  searchedProdCodeTableData,
  prodCodeMastercarrierId,
  prodAddState,
  isProdCodeFilterOpen,
  defaultProdSearchParams,
  prodCodeIsFranchise,
  carrierNameValue,
} from "./atoms/atoms";
import { notificationFilterById } from "../../../actions/Utilities/NotificationFilter";
import useSearchProducerCode from "./hooks/useSearchProducerCode";
import useGetProducerCodes from "./hooks/useGetProducerCodes";
import { useGetCarriers } from "../Carrier/hooks/useGetCarriers";
import useSendEmail from "./hooks/useSendEmail";

const ProducerCodeConfig = () => {
  const [filteredProducerCodeData, setFilteredproducerCodeData] = useState([]);
  const [filterStatus, setFilterStatus] = useRecoilState(isProdCodeFilterOpen);
  const [addMainProducerCode, setAddMainProducerCode] = useState(false);
  const [addMainForm] = useState(false);
  const [modalArgs, setModalArgs] = useState({});
  const [toggledRows, setToggledRows] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchInputsData, setSearchInputsData] =
    useRecoilState(searchDataProdCode);
  const [isFilterMainTable, setIsFilterMainTable] = useState(false);
  const [, setsearchProducerCodeInputsData] = useRecoilState(
    searchedProdCodeTableData
  );
  const queryClient = useQueryClient();
  const [isRefreshModal, setIsRefreshModal] = useState(false);
  const [massUploadModal, setMassUploadModal] = useState(false);
  const addPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_producercode_add;
  const userPermissions = useRecoilValue(permissionsSelector);
  const [completeCarrierData, setCompleteCarrierData] = useState([]);
  const [saveModal, setSaveModal] = useState(false);
  const [buttonText, setButtonText] = useState("Save");
  //Recoils\Atoms
  const [openModalEdit, setOpenModalEdit] = useRecoilState(isEditStateProducer);
  const setRowForEdit = useSetRecoilState(rowForEditProducer);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isFranchise, setIsFranchise] = useRecoilState(prodCodeIsFranchise);
  const user = useRecoilValue(accountAtom);
  const {
    data: groupedProducerCodes,
    isLoading: getGrpProdCodeLoading,
    refetch: refetchGetGrpProdCode,
  } = useGetProducerCodes();

  const handleSaveNewProducerCode = () => {
    saveNewProducerCode.mutate(carrierProducerCodeData);
  };
  const [selectedCarrierName, setSelectedCarrierName] =
    useRecoilState(carrierNameValue);
  const [, setAddState] = useRecoilState(prodAddState);
  const [masterCarrierIdValue, setMasterCarrierId] = useRecoilState(
    prodCodeMastercarrierId
  );
  const { mutateAsync: sendProdCodeEmail, isSuccess: emailSuccess } =
    useSendEmail();

  const carrierProducerCodeRow = {
    RowId: 1,
    MasterCarrierId: "",
    CarrierName: "",
    Address: "",
    City: "",
    State: "",
    isActive: false,
    CreatedDate: "",
    CreatedBy: "",
    ModifiedDate: "",
    ModifiedBy: "",
    OfficeCode: "",
    StoreNumber: 0,
    AssociatedTo: "",
    Producer: "",
    PrincetonAgentCode: "",
    MasterAgentPrincetonID: 0,
    IsSuperUser: false,
    IsFranchise: false,
    IsRemoveDropdowns: false,
    IsResetCarrierDependency: false,
    ProducerCodes: [
      {
        RowId: 1,
        producerCodeRowId: 1,
        ProducerCode: "",
        ProducerSubCode: "",
        ProducerCodeTypeId: "",
        LineOfBusiness: 0,
        Program: 0,
        MGA: 0,
        DistributionChannelId: 0,
        MasterCode: "",
        MasterCodeStatus: true,
        CodeLevel: "",
        IssuedTo: [],
        RollUpId: 0,
        RollUpCodeStatus: true,
        CrossSale: [],
      },
    ],
  };

  let recordFromRecent = "";
  let location = useLocation();
  let recordIdFromRecent = "";
  const history = useHistory();
  if (location.state != null) {
    recordFromRecent = location.state;
  }
  if (location.state != null) {
    recordIdFromRecent = location.state;
  }

  useEffect(() => {
    if (isRefreshModal) {
      refreshModalContent();
    }
    setOpenModalEdit(false);
    setRowForEdit([]);
    setSearchInputsData(defaultProdSearchParams);
  }, []);

  //Refresh modal filter and table
  const refreshModalContent = () => {
    localStorage.removeItem("NotifFilter");
    localStorage.removeItem("ModuleFilter");
    setSearchInputsData([]);
    setsearchProducerCodeInputsData([]);
    setIsRefreshModal(true);
  };

  const [carrierProducerCodeData, setcarrierProducerCodeData] = useState([
    carrierProducerCodeRow,
  ]);
  let newDate = new Date().toLocaleDateString();
  let newTime = new Date().toLocaleTimeString();
  const [saveDisabled, setsaveDisabled] = useState(true);
  const [hasEmptyValidFields, setHasEmptyValidFields] = useState(true);

  const handleClickSave = () => {
    setSaveModal(false);
    setButtonText("Saving...");

    if (!hasEmptyValidFields) {
      setsaveDisabled(true);
      handleSaveNewProducerCode();
    } else {
      setButtonText("Save");
      setsaveDisabled(false);
      toast.fire(
        "Saving Failed",
        "All required fields must be filled!",
        "error"
      );
    }
  };
  //to disable save button if required field has no value
  useEffect(() => {
    carrierProducerCodeData.map((prodData) => {
      prodData.MasterCarrierId = masterCarrierIdValue
        ? masterCarrierIdValue
        : prodData.MasterCarrierId;
      if (
        prodData.MasterCarrierId === null ||
        prodData.MasterCarrierId === "" ||
        (prodData.AssociatedTo === "Office"
          ? prodData.OfficeCode === ""
          : prodData.Producer === "") ||
        (selectedCarrierName === "National General"
          ? prodData.PrincetonAgentCode === ""
          : !prodData.PrincetonAgentCode === "")
      ) {
        setsaveDisabled(true);
      }
      prodData.ProducerCodes.map((prod) => {
        if (
          prod.LineOfBusiness === null ||
          (prod.isMA === true && prod.MAProducerCodes === "")
        ) {
          setsaveDisabled(true);
        }
      });
    });
  });
  const { data: carriersQuery } = useGetCarriers();
  // Filter for Carrier View Setting and from recent activity
  useEffect(() => {
    if (
      recordIdFromRecent &&
      recordIdFromRecent.moduleName === "Producer Code"
    ) {
      if (
        recordIdFromRecent.action === "viewSettings" &&
        groupedProducerCodes &&
        carriersQuery
      ) {
        setFilterStatus(true);
        setIsFilterMainTable(true);

        setSearchInputsData({
          ...searchInputsData,
          selectedCarrier: carriersQuery
            ?.filter((x) => x.carrierName === recordIdFromRecent.recordId)
            .map((y) => ({
              label: y.carrierName,
              value: y.masterCarrierId,
            })),
        });

        setFilteredproducerCodeData(
          groupedProducerCodes?.filter(
            (x) => x.carrierName === recordIdFromRecent.recordId
          )
        );
        history.replace();
      } else {
        setIsFilterMainTable(true);
        notificationFilterById(
          recordIdFromRecent.recordId?.toString(),
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName,
          recordIdFromRecent.action
        ).then((result) => {
          if (result) {
            if (result.exception) {
              setFilteredproducerCodeData([]);
              toast.fire(
                "Server Error",
                "Failed to retrieve Producer Code data",
                "error"
              );
            } else {
              setFilteredproducerCodeData(result.result);
            }
          }
          history.replace();
        });
      }
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, [groupedProducerCodes, carriersQuery]);

  // Export Producer Codes
  //Add new producer function

  const saveNewProducerCode = useMutation(
    (newCarrier) => addProducerCode(newCarrier),
    {
      onSuccess: (res) => {
        setButtonText("Save");
        if (res.status === 201 || res.status === 200) {
          sendProdCodeEmail(res.data, {
            onSuccess: (res) => {
              if (res) {
                searcProdCodeRefetch().then((result) => {
                  if (result.isSuccess && result.data) {
                    if (res.status === 400) {
                      toast.fire(
                        "Success",
                        "New Producer Code Added Successfully, but failed in sending email",
                        "warning"
                      );
                    } else {
                      toast.fire(
                        "Success",
                        "New Producer Code Added Successfully",
                        "success"
                      );
                    }
                    refetchGetGrpProdCode();
                    queryClient.invalidateQueries("ProducerCode");
                    handleSetAddMainProducerCode();
                    setSelectedRows([]);
                    setToggledRows(!toggledRows);
                    setsaveDisabled(true);
                    setSaveModal(false);
                    setAddState(false);
                    setMasterCarrierId(undefined);
                    setcarrierProducerCodeData([carrierProducerCodeRow]);
                    if (res.data) {
                      const newIds = res.data.join(",");
                      setModalArgs({
                        ...modalArgs,
                        carrierProducerCodeIds:
                          modalArgs.carrierProducerCodeIds +
                          "," +
                          newIds.replace(/,\s*$/, ""), //remove extra comma
                      });
                    }
                  }
                });
              }
            },
          });
        } else if (
          res.status === 400 ||
          res.status === 204 ||
          res.data === "duplicate producer code"
        ) {
          toast.fire(
            "Failed ",
            "Failed to Add Producer code! Already Exist.",
            "error"
          );
          setsaveDisabled(false);
        } else {
          toast.fire("Error", "Saving Failed: Server Error", "error");
          setsaveDisabled(false);
        }
      },
      onError: (error) => {
        setsaveDisabled(false);
        if (
          error.response.data.message === "Failed sending of email" ||
          error.response.data.message === "Failed inserting of notification"
        ) {
          toast.fire(
            "Add Producer Code",
            "New Producer Code added successfully, but " +
              error.response.data.message,
            "warning"
          );
          handleSetAddMainProducerCode();
          setSelectedRows([]);
          setToggledRows(!toggledRows);
          setAddState(false);
          setMasterCarrierId(undefined);
          setcarrierProducerCodeData([carrierProducerCodeRow]);
        } else {
          toast.fire(
            "Adding new Producer Code  failed",
            "Server Error: Cannot add new Producer Code",
            "error"
          );
          setsaveDisabled(false);
        }
      },
    }
  );

  const handleMACheckBox = (e, row) => {
    // const checked = e.target.checked;
    var rowIndex = carrierProducerCodeData.findIndex(
      (obj) => obj.RowId === row.RowId
    );
    const checked = e.target.checked;
    if (checked) {
      //checked

      setcarrierProducerCodeData((cpcd) =>
        cpcd.map((item, i) => {
          if (i === rowIndex)
            item.ProducerCodes.map((pRow) => {
              if (pRow.producerCodeRowId === row.producerCodeRowId) {
                pRow.isMA = true;

                // handleProducerCodeInputs(
                //   "ProducerAddressTable",
                //   "M&A",
                //   "",
                //   row.masterCarrierId,
                //   row.state,
                //   row.RowId,
                //   row.producerCodeRowId == null ? 1 : row.producerCodeRowId,
                //   addMainForm
                // );
              }
              if (
                pRow.producerCodeRowId === row.producerCodeRowId &&
                pRow.MAProducerCodes === ""
              ) {
                setHasEmptyValidFields(true);
                setsaveDisabled(true);
              }
              return pRow;
            });
          return item;
        })
      );
    } else {
      //unchecked
      setcarrierProducerCodeData((cpcd) =>
        cpcd.map((item, i) => {
          if (i === rowIndex)
            item.ProducerCodes.map((pRow) => {
              if (pRow.producerCodeRowId === row.producerCodeRowId) {
                pRow.isMA = false;
                pRow.MAProducerCodes = "";
                handleProducerCodeInputs(
                  "ProducerAddressTable",
                  "M&A",
                  "",
                  row.masterCarrierId,
                  row.state,
                  row.RowId,
                  row.producerCodeRowId == null ? 1 : row.producerCodeRowId,
                  addMainForm
                );
              }
              return pRow;
            });
          return item;
        })
      );
      // carrierProducerCodeData[rowIndex].isMA = false;

      // carrierProducerCodeData[rowIndex].ModifiedBy =
      //   localStorage.getItem("userName");
    }
  };

  //Function for Super User Data category
  const handleIsFranchise = (isFranchise) => {
    setcarrierProducerCodeData((cpcd) =>
      cpcd.map((item, i) => {
        item.ProducerCodes.map((pRow) => {
          pRow.isFranchise = isFranchise;
          return pRow;
        });
        return item;
      })
    );
  };

  const handlecarrierStateInputs = (
    tableName,
    fieldName,
    selectedValue,
    masterCarrierId,
    state,
    rowId,
    producerCodeRowId,
    addMainForm
  ) => {};

  //Function for Producer Code Table Select Input
  const handleProducerCodeInputs = (
    tableName,
    fieldName,
    selectedValue,
    masterCarrierId,
    state,
    rowId,
    producerCodeRowId,
    addMainForm,
    masterRollStatus
  ) => {
    if (tableName === "ProducerAddressTable") {
      var rowIndex = carrierProducerCodeData.findIndex(
        (obj) => obj.RowId === rowId
      );
      if (fieldName === "CarrierName") {
        carrierProducerCodeData[rowIndex].MasterCarrierId = selectedValue;
        carrierProducerCodeData[rowIndex].CarrierName = selectedCarrierName;
        carrierProducerCodeData[rowIndex].isActive = true;
        carrierProducerCodeData[rowIndex].CreatedDate = newDate + " " + newTime;
        carrierProducerCodeData[rowIndex].CreatedBy = user?.username;
        carrierProducerCodeData[rowIndex].ModifiedDate =
          newDate + " " + newTime;
        carrierProducerCodeData[rowIndex].ModifiedBy = user?.username;
        carrierProducerCodeData[rowIndex].IsResetCarrierDependency = true;
        carrierProducerCodeData[rowIndex].IsSuperUser =
          user?.isFranchise && user?.isNonFranchise;

        //Resetting Dropdown of Carrier Program, Master Code and Roll Up Code
        setcarrierProducerCodeData((cpcd) =>
          cpcd.map((item, i) => {
            item.ProducerCodes.map((pRow) => {
              pRow.MasterCode = "";
              pRow.Program = 0;
              pRow.RollUpId = 0;
              pRow.MasterCodeStatus = true;
              pRow.RollUpCodeStatus = true;

              return pRow;
            });
            return item;
          })
        );
      }
      if (fieldName !== "CarrierName") {
        carrierProducerCodeData[rowIndex].IsResetCarrierDependency = false;
      }
      if (fieldName === "OfficeCodeStoreNumber") {
        setcarrierProducerCodeData((cpcd) =>
          cpcd.map((item, i) => {
            if (i === rowIndex && selectedValue != null) {
              const officeCodeStoreNumberCombination =
                selectedValue?.split("-");
              item.StoreNumber =
                officeCodeStoreNumberCombination.length > 0
                  ? officeCodeStoreNumberCombination[1]?.trim()
                  : "";
              item.OfficeCode =
                officeCodeStoreNumberCombination.length > 0
                  ? officeCodeStoreNumberCombination[0]?.trim()
                  : "";
              item.MasterCarrierId = masterCarrierId;
              item.State = state;
            } else if (i === rowIndex && selectedValue === null) {
              item.OfficeCode = null;
            }
            return item;
          })
        );
      }

      if (fieldName === "AssociatedTo") {
        setcarrierProducerCodeData((cpcd) =>
          cpcd.map((item, i) => {
            if (i === rowIndex && selectedValue != null) {
              if (selectedValue === "Office") {
                item.Producer = null;
              } else if (selectedValue === "Producer") {
                item.StoreNumber = null;
                item.OfficeCode = null;
              }
              item.AssociatedTo = selectedValue;
            } else if (i === rowIndex && selectedValue === null) {
              item.AssociatedTo = "";
            }
            return item;
          })
        );
      }
      // if (fieldName === "IsFranchise") {
      //   setcarrierProducerCodeData((cpcd) =>
      //     cpcd.map((item, i) => {
      //       if (i === rowIndex && selectedValue != null) {
      //         item.IsFranchise = selectedValue;
      //         item.OfficeCode = "";
      //         item.Producer = "";
      //         item.ProducerCodes.map((pRow) => {
      //           pRow.IssuedTo = [];
      //           pRow.MasterCode = "";
      //           pRow.RollUpId = 0;
      //           pRow.MasterCodeStatus = true;
      //           pRow.RollUpCodeStatus = true;
      //           return pRow;
      //         });
      //         item.IsRemoveDropdowns = true;
      //       } else if (i === rowIndex && selectedValue === null) {
      //         item.IsFranchise = false;
      //         item.OfficeCode = "";
      //         item.Producer = "";
      //         item.ProducerCodes.map((pRow) => {
      //           pRow.IssuedTo = [];
      //           pRow.MasterCode = "";
      //           pRow.RollUpId = 0;
      //           pRow.MasterCodeStatus = true;
      //           pRow.RollUpCodeStatus = true;
      //           return pRow;
      //         });
      //         item.IsRemoveDropdowns = true;
      //       }
      //       return item;
      //     })
      //   );
      // }
      if (fieldName === "Producer") {
        setcarrierProducerCodeData((cpcd) =>
          cpcd.map((item, i) => {
            if (i === rowIndex && selectedValue != null) {
              item.Producer = selectedValue;
            } else if (i === rowIndex && selectedValue === null) {
              item.Producer = "";
            }
            return item;
          })
        );
      }
      if (fieldName === "producerCode") {
        setcarrierProducerCodeData((cpcd) =>
          cpcd.map((item, i) => {
            if (i === rowIndex)
              item.ProducerCodes.map((pRow) => {
                if (pRow.producerCodeRowId === producerCodeRowId) {
                  pRow.ProducerCode = selectedValue;
                  pRow.isMA = false;
                  pRow.MAProducerCodes = "";
                }
                return pRow;
              });
            return item;
          })
        );
        if (addMainForm === false) {
          carrierProducerCodeData[rowIndex].MasterCarrierId = masterCarrierId;
          carrierProducerCodeData[rowIndex].State = state;
          carrierProducerCodeData[rowIndex].isActive = true;
          carrierProducerCodeData[rowIndex].CreatedDate =
            newDate + " " + newTime;
          carrierProducerCodeData[rowIndex].CreatedBy = user?.username;
          carrierProducerCodeData[rowIndex].ModifiedDate =
            newDate + " " + newTime;
          carrierProducerCodeData[rowIndex].ModifiedBy = user?.username;
        }
      }
      if (user.isFranchise && user.isNonFranchise) {
        if (fieldName === "producerSubCode") {
          setcarrierProducerCodeData((cpcd) =>
            cpcd.map((item, i) => {
              if (i === rowIndex)
                item.ProducerCodes.map((pRow) => {
                  if (pRow.producerCodeRowId === producerCodeRowId) {
                    pRow.isFil = selectedValue;
                  }
                  return pRow;
                });
              return item;
            })
          );
        }
      }
      if (fieldName === "producerSubCode") {
        setcarrierProducerCodeData((cpcd) =>
          cpcd.map((item, i) => {
            if (i === rowIndex)
              item.ProducerCodes.map((pRow) => {
                if (pRow.producerCodeRowId === producerCodeRowId) {
                  pRow.ProducerSubCode = selectedValue;
                }
                return pRow;
              });
            return item;
          })
        );
      }
      if (fieldName === "IssuedTo") {
        setcarrierProducerCodeData((cpcd) =>
          cpcd.map((item, i) => {
            if (i === rowIndex)
              item.ProducerCodes.map((pRow) => {
                if (pRow.producerCodeRowId === producerCodeRowId) {
                  pRow.IssuedTo = selectedValue;
                  item.IsRemoveDropdowns = false;
                }
                return pRow;
              });
            return item;
          })
        );
      }
      if (fieldName === "CrossSale") {
        setcarrierProducerCodeData((cpcd) =>
          cpcd.map((item, i) => {
            if (i === rowIndex)
              item.ProducerCodes.map((pRow) => {
                if (pRow.producerCodeRowId === producerCodeRowId) {
                  pRow.CrossSale = selectedValue;
                  item.IsRemoveDropdowns = false;
                }
                return pRow;
              });
            return item;
          })
        );
      }
      if (fieldName === "masterCode") {
        setcarrierProducerCodeData((cpcd) =>
          cpcd.map((item, i) => {
            if (i === rowIndex)
              item.ProducerCodes.map((pRow) => {
                if (pRow.producerCodeRowId === producerCodeRowId) {
                  pRow.MasterCode = selectedValue;
                  pRow.MasterCodeStatus = masterRollStatus;
                  item.IsRemoveDropdowns = false;
                }
                return pRow;
              });
            return item;
          })
        );
      }
      if (fieldName === "rollUpCode") {
        setcarrierProducerCodeData((cpcd) =>
          cpcd.map((item, i) => {
            if (i === rowIndex)
              item.ProducerCodes.map((pRow) => {
                if (pRow.producerCodeRowId === producerCodeRowId) {
                  pRow.RollUpId = selectedValue;
                  pRow.RollUpCodeStatus = masterRollStatus;
                  item.IsRemoveDropdowns = false;
                }
                return pRow;
              });
            return item;
          })
        );
      }
      if (fieldName === "masterCodeStatus") {
        setcarrierProducerCodeData((cpcd) =>
          cpcd.map((item, i) => {
            if (i === rowIndex)
              item.ProducerCodes.map((pRow) => {
                if (pRow.producerCodeRowId === producerCodeRowId) {
                  pRow.MasterCodeStatus = selectedValue;
                  item.IsRemoveDropdowns = false;
                }
                return pRow;
              });
            return item;
          })
        );
      }
      if (fieldName === "rollUpCodeStatus") {
        setcarrierProducerCodeData((cpcd) =>
          cpcd.map((item, i) => {
            if (i === rowIndex)
              item.ProducerCodes.map((pRow) => {
                if (pRow.producerCodeRowId === producerCodeRowId) {
                  pRow.RollUpCodeStatus = selectedValue;
                  item.IsRemoveDropdowns = false;
                }
                return pRow;
              });
            return item;
          })
        );
      }
      if (fieldName === "CodeLevel") {
        carrierProducerCodeData[rowIndex].ProducerCodes.map((pRow) => {
          if (pRow.producerCodeRowId === producerCodeRowId) {
            pRow.CodeLevel = selectedValue;
          }
        });
      }
      if (fieldName === "lineOfBusiness") {
        carrierProducerCodeData[rowIndex].ProducerCodes.map((pRow) => {
          if (pRow.producerCodeRowId === producerCodeRowId) {
            pRow.LineOfBusiness = selectedValue;
          }
        });
      }
      if (fieldName === "ProducerCodeType") {
        carrierProducerCodeData[rowIndex].ProducerCodes.map((pRow) => {
          if (pRow.producerCodeRowId === producerCodeRowId) {
            pRow.ProducerCodeTypeId = selectedValue;
          }
        });
      }

      if (fieldName === "M&A") {
        setcarrierProducerCodeData((cpcd) =>
          cpcd.map((item, i) => {
            if (i === rowIndex)
              item.ProducerCodes.map((pRow) => {
                if (pRow.producerCodeRowId === producerCodeRowId) {
                  pRow.MAProducerCodes = selectedValue;
                }
                return pRow;
              });
            return item;
          })
        );
      }
      if (fieldName === "program") {
        setcarrierProducerCodeData((cpcd) =>
          cpcd.map((item, i) => {
            if (i === rowIndex)
              item.ProducerCodes.map((pRow) => {
                if (pRow.producerCodeRowId === producerCodeRowId) {
                  pRow.Program = selectedValue;
                }
                return pRow;
              });
            return item;
          })
        );
      }
      if (fieldName === "mga") {
        setcarrierProducerCodeData((cpcd) =>
          cpcd.map((item, i) => {
            if (i === rowIndex)
              item.ProducerCodes.map((pRow) => {
                if (pRow.producerCodeRowId === producerCodeRowId) {
                  pRow.MGA = selectedValue;
                }
                return pRow;
              });
            return item;
          })
        );
      }
      if (fieldName === "districhannel") {
        setcarrierProducerCodeData((cpcd) =>
          cpcd.map((item, i) => {
            if (selectedValue === 6) {
              setIsFranchise(true);
              item.IsFranchise = true;
              item.OfficeCode = "";
              item.Producer = "";
              item.ProducerCodes.map((pRow) => {
                pRow.IssuedTo = [];
                pRow.MasterCode = "";
                pRow.RollUpId = 0;
                pRow.MasterCodeStatus = true;
                pRow.RollUpCodeStatus = true;
                return pRow;
              });
              item.IsRemoveDropdowns = true;
            } else if (i === rowIndex && selectedValue !== 6) {
              setIsFranchise(false);
              item.IsFranchise = false;
              item.OfficeCode = "";
              item.Producer = "";
              item.ProducerCodes.map((pRow) => {
                pRow.IssuedTo = [];
                pRow.MasterCode = "";
                pRow.RollUpId = 0;
                pRow.MasterCodeStatus = true;
                pRow.RollUpCodeStatus = true;
                return pRow;
              });
              item.IsRemoveDropdowns = true;
            }
            if (i === rowIndex)
              item.ProducerCodes.map((pRow) => {
                if (pRow.producerCodeRowId === producerCodeRowId) {
                  pRow.DistributionChannelId = selectedValue;
                }
                return pRow;
              });
            return item;
          })
        );
      }
      if (fieldName === "princetonAgentCode") {
        carrierProducerCodeData[rowIndex].PrincetonAgentCode = selectedValue;
      }
      if (fieldName === "masterAgentPrincetonId") {
        carrierProducerCodeData[rowIndex].MasterAgentPrincetonId =
          selectedValue;
      }
      handleValidateProducerCodeTabledata();
    }
  };

  //Function for export producer codes
  const handleExportButton = () => {
    try {
      var myCurrentDate = new Date();
      var date =
        myCurrentDate.getFullYear() +
        "-" +
        (myCurrentDate.getMonth() + 1) +
        "-" +
        myCurrentDate.getDate() +
        " " +
        myCurrentDate.getHours() +
        ":" +
        myCurrentDate.getMinutes() +
        ":" +
        myCurrentDate.getSeconds();
      if (user.isFranchise && user.isNonFranchise) {
        if (isFilterMainTable) {
          exportProducerCodes(
            filteredProducerCodeData,
            user.isFranchise,
            user.isNonFranchise
          ).then((content) => {
            var url = window.URL.createObjectURL(content.data);
            let tempLink = document.createElement("a");
            tempLink.href = url;

            tempLink.setAttribute(
              "download",
              "ProducerCodes " + date + ".xlsx"
            );
            tempLink.click();
            // store.addNotification(
            setIsDownloading(false);
            toast.fire(
              "Success",
              "Producer codes were exported successfully",
              "success"
            );
            // );
          });
        } else {
          exportProducerCodes(
            groupedProducerCodes,
            user.isFranchise,
            user.isNonFranchise
          ).then((content) => {
            var url = window.URL.createObjectURL(content.data);
            let tempLink = document.createElement("a");
            tempLink.href = url;
            tempLink.setAttribute(
              "download",
              "ProducerCodes " + date + ".xlsx"
            );
            tempLink.click();
            // store.addNotification(
            setIsDownloading(false);
            toast.fire(
              "Success",
              "Producer codes were exported successfully",
              "success"
            );
            // );
          });
        }
      } else {
        if (isFilterMainTable) {
          exportProducerCodes(
            filteredProducerCodeData,
            user.isFranchise,
            user.isNonFranchise
          ).then((content) => {
            var url = window.URL.createObjectURL(content.data);
            let tempLink = document.createElement("a");
            tempLink.href = url;
            tempLink.setAttribute(
              "download",
              "ProducerCodes " + date + ".xlsx"
            );
            tempLink.click();
            // store.addNotification(
            setIsDownloading(false);
            toast.fire(
              "Success",
              "Producer codes were exported successfully",
              "success"
            );
            // );
          });
        } else {
          exportProducerCodes(
            groupedProducerCodes,
            user.isFranchise,
            user.isNonFranchise
          ).then((content) => {
            var url = window.URL.createObjectURL(content.data);
            let tempLink = document.createElement("a");
            tempLink.href = url;
            tempLink.setAttribute(
              "download",
              "ProducerCodes " + date + ".xlsx"
            );
            tempLink.click();
            // store.addNotification(
            setIsDownloading(false);
            toast.fire(
              "Success",
              "Producer codes were exported successfully",
              "success"
            );
            // );
          });
        }
      }
    } catch (error) {
      toast.fire(
        "Failed",
        "Server Error: Cannot export producer codes due to: " + error,
        "error"
      );
    }
  };

  //Function for new Address row in Carrier Producer  table only
  const handleAddcarrierProducerCodeRow = (rowDetails, tableName) => {
    var dataTable = [];
    if (tableName === "ProducerAddressTable") {
      dataTable = carrierProducerCodeData;
    }

    const newRow = {
      RowId: dataTable.length + 1,
      MasterCarrierId: 0,
      State: "",
      isActive: false,
      IsFranchise: false,
      Address: "",
      City: "",
      CreatedDate: "",
      CreatedBy: "",
      ModifiedDate: "",
      ModifiedBy: "",
      OfficeCode: "",
      StoreNumber: 0,
      AssociatedTo: "",
      Producer: "",
      IsSuperUser: false,
      IsRemoveDropdowns: false,
      IsResetCarrierDependency: false,
      ProducerCodes: [
        {
          RowId: dataTable.length + 1,
          producerCodeRowId: 1,
          ProducerCode: "",
          ProducerSubCode: "",
          ProducerCodeTypeId: "",
          LineOfBusiness: 0,
          Program: 0,
          MGA: 0,
          DistributionChannelId: 0,
          MasterCode: "",
          MasterCodeStatus: true,
          CodeLevel: "",
          IssuedTo: [],
          RollUpCodeStatus: true,
          RollUpId: 0,
          CrossSale: [],
        },
      ],
    };
    if (tableName === "ProducerAddressTable") {
      carrierProducerCodeData.push(newRow);
      setcarrierProducerCodeData([...carrierProducerCodeData]);
      handleValidateProducerCodeTabledata();
    }
  };

  //Function for removing rows in producer tables
  const handleRemovecarrierAddress = (rowDetails, tableName) => {
    if (tableName === "ProducerAddressTable") {
      const dataLeft = carrierProducerCodeData.filter(
        (row) => row.RowId !== rowDetails.RowId
      );
      const newRows = dataLeft.map((row, index) => {
        return {
          ...row,
          RowId: index + 1,
          ProducerCodes: row.ProducerCodes.map((pRow, index) => {
            return { ...pRow, producerCodeRowId: index + 1 };
          }),
        };
      });
      setcarrierProducerCodeData([...newRows]);
    }
    handleValidateProducerCodeTabledata();
  };

  //validation
  const handleValidateProducerCodeTabledata = () => {
    //Check other rows if populated
    setCompleteCarrierData([]);
    carrierProducerCodeData.forEach((data) => {
      if (
        data.MasterCarrierId === 0 ||
        data.AssociatedTo === "" ||
        (data.AssociatedTo === "Office"
          ? data.OfficeCode === ""
          : data.Producer === "")
      ) {
        completeCarrierData.push(true);
      }
      // if (
      //   data.MasterCarrierId === "National General" &&
      //   data.PrincetonAgentCode === ""
      // ) {
      //   completeCarrierData.push(true);
      // }
      else {
        completeCarrierData.push(false);
      }

      //check ProdCode and Line of Business
      //Additional: MAProducerCodes in Validation
      data.ProducerCodes.forEach((prod) => {
        if (
          prod.ProducerCode === "" ||
          prod.CodeLevel === "" ||
          prod.CodeLevel === null ||
          prod.ProducerCodeTypeId === "" ||
          prod.ProducerCodeTypeId === null ||
          prod.ProducerCodeTypeId === 0 ||
          prod.LineOfBusiness === 0 ||
          prod.LineOfBusiness === ""
        ) {
          completeCarrierData.push(true);
        } else {
          completeCarrierData.push(false);
        }
      });
    });
    if (completeCarrierData.includes(true)) {
      setsaveDisabled(true);
      setHasEmptyValidFields(true);
    } else {
      setsaveDisabled(false);
      setHasEmptyValidFields(false);
    }
  };

  const handleSetAddMainProducerCode = (status) => {
    setAddMainProducerCode(status);
  };
  const handleAddProducerCodeRow = (rowDetails, tableName) => {
    var producerCodeRowId = 0;
    const producerCode = {
      RowId: rowDetails.RowId,
      producerCodeRowId: 0,
      ProducerCode: "",
      ProducerSubCode: "",
      ProducerCodeTypeId: 0,
      LineOfBusiness: 0,
      CodeLevel: "",
      MasterCode: "",
      MasterCodeStatus: true,
      RollUpCodeStatus: true,
      RollUpId: 0,
    };

    if (tableName === "ProducerAddressTable") {
      carrierProducerCodeData.filter((row) => {
        if (row.RowId === rowDetails.RowId) {
          producerCodeRowId = row.ProducerCodes.length;
        }
      });
      carrierProducerCodeData.map((row) => {
        if (row.RowId === rowDetails.RowId) {
          row.ProducerCodes.push({
            ...producerCode,
            RowId: rowDetails.RowId,
            producerCodeRowId: parseInt(producerCodeRowId) + 1,
          });
          setcarrierProducerCodeData([...carrierProducerCodeData]);
          handleValidateProducerCodeTabledata();
        }
      });
    }
  };

  const handleRemoveProducerCodeRow = (rowDetails, tableName) => {
    if (tableName === "ProducerAddressTable") {
      carrierProducerCodeData.map((row) => {
        if (row.RowId === rowDetails.RowId) {
          row.ProducerCodes.filter((producerCodeRow, index) => {
            if (
              producerCodeRow.producerCodeRowId === rowDetails.producerCodeRowId
            ) {
              row.ProducerCodes.splice(index, 1);
            }
          });
        }
      });
      setcarrierProducerCodeData([...carrierProducerCodeData]);
      handleValidateProducerCodeTabledata();
    }
  };

  //UseHooks for filtered main agreement table data
  const {
    isSuccess: searchProdCodeSuccess,
    data: filteredProdCodeData,
    isFetching: searchProdCodeLoading,
    refetch: searcProdCodeRefetch,
  } = useSearchProducerCode({ filterParams: searchInputsData });

  useEffect(() => {
    if (searchProdCodeSuccess && filteredProdCodeData)
      if (filteredProdCodeData.statusCode) {
        toast.fire("Server Error", "Cannot Get Producer Code Data", "error");
        setFilteredproducerCodeData([]);
      } else {
        setFilteredproducerCodeData(filteredProdCodeData);
        setIsFilterMainTable(true);
      }
  }, [searchProdCodeSuccess, filteredProdCodeData]);
  return (
    <Fragment>
      {massUploadModal && (
        <MassUpload
          isOpen={massUploadModal}
          setMassUploadModal={setMassUploadModal}
          groupedProducerCodes={groupedProducerCodes}
        />
      )}
      {/* This table is for Producer Main Table  */}
      {!massUploadModal && (
        <div className="w-full grid grid-row">
          <ProducerCodeMainTable
            data={
              isFilterMainTable
                ? filteredProducerCodeData
                : groupedProducerCodes
            }
            setMassUploadModal={setMassUploadModal}
            args={modalArgs}
            setModalArgs={setModalArgs}
            handleProducerCodeInputs={handleProducerCodeInputs}
            handleRemovecarrierAddress={handleRemovecarrierAddress}
            handlecarrierStateInputs={handlecarrierStateInputs}
            handleAddcarrierProducerCodeRow={handleAddcarrierProducerCodeRow}
            handleAddProducerCodeRow={handleAddProducerCodeRow}
            handleRemoveProducerCodeRow={handleRemoveProducerCodeRow}
            handleExportButton={handleExportButton}
            setIsDownloading={setIsDownloading}
            isDownloading={isDownloading}
            carrierProducerCodeData={carrierProducerCodeData}
            addMainProducerCode={addMainProducerCode}
            addMainForm={addMainForm}
            handleClickSave={handleClickSave}
            setAddMainProducerCode={handleSetAddMainProducerCode}
            searcProdCodeRefetch={searcProdCodeRefetch}
            setFilterStatus={setFilterStatus}
            setcarrierProducerCodeData={setcarrierProducerCodeData}
            carrierProducerCodeRow={carrierProducerCodeRow}
            tableloading={
              filterStatus ? searchProdCodeLoading : getGrpProdCodeLoading
            }
            saveDisabled={saveDisabled}
            handleMACheckBox={handleMACheckBox}
            handleIsFranchise={handleIsFranchise}
            saveModal={saveModal}
            setSaveModal={setSaveModal}
            setFilteredproducerCodeData={setFilteredproducerCodeData}
            buttonText={buttonText}
            setOpenModalEdit={setOpenModalEdit}
            openModalEdit={openModalEdit}
            setIsFilterMainTable={setIsFilterMainTable}
            groupedProducerCodes={groupedProducerCodes}
          />
        </div>
      )}
    </Fragment>
  );
};

export default ProducerCodeConfig;
